import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'
import { Link } from 'react-router-dom'

export const SelfServeWidgetsContainer = styled(Box)``

export const Header = styled(Typography)`
  padding-bottom: 20px;

  ${typography.up3.semiBoldSans}
`

export const WidgetCards = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`

export const WidgetLink = styled(Link)`
  color: ${colors.text.primary};
`

export const WidgetCard = styled(Box)`
  background-color: ${colors.background.secondaryBackground};
  border: 1px solid ${colors.grey[300]};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: 185px;
  justify-content: space-between;
  padding: 16px;
  transition: all 0.3s;
  width: 280px;

  &:hover {
    transform: scale(1.05);
  }
`

export const WidgetDetails = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const WidgetName = styled(Typography)`
  ${typography.up1.semiBoldSans}
`

export const WidgetDescription = styled(Typography)`
  ${typography.baseline.regularSans}
`

export const ChipContainer = styled(Box)`
  align-items: center;
  display: flex;
  gap: 5px;
`
